import React from 'react';
import { Col, Container, Row, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import car from './car-insurance.png';

const DefinitionSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <Container>
        <Row>
          <Col lg={10} className="mx-auto">
            <Row className="gy-5 align-items-center">
              <Col lg={5} className="text-center">
                <Image src={car as string} fluid alt="MGA Cover car insurance" className="w-75" />
              </Col>
              <Col lg={7} className="p-5">
                <h2>{t('carInsurancePage.definitionSection.title')}</h2>
                <p>{t('carInsurancePage.definitionSection.description')}</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export { DefinitionSection };
